import React from "react";
import PropTypes from "prop-types";
import { MediaTypeImage } from "../../../mediaTypeImage";
import { Box } from "@mzc-pdc/ui";
import { alpha } from "@mui/material";

const MediaImage = ({ url, mediaType, draggable }) => (
    <Box
        draggable={draggable}
        sx={{
            position: `relative`,
            minWidth: 44,
            width: 44,
            height: 44,
            borderRadius: `4px`,
            backgroundColor: alpha("#e5e7ed", 0.5),
            overflow: `hidden`,
            mr: 1.5,
        }}
    >
        <MediaTypeImage
            mediaType={mediaType}
            src={url}
            draggable={draggable}
            variant={"table"}
            width={28}
            height={28}
        />
    </Box>
);
MediaImage.propTypes = {
    url: PropTypes.string,
    mediaType: PropTypes.string,
    draggable: PropTypes.bool,
};

export default MediaImage;
